import { Box } from '@mui/material';

/**
 * Compact payment mode badge.
 * COD → red, everything else → green.
 *
 * Props:
 *   mode  string  — payment mode string (e.g. 'COD', 'PREPAID')
 */
export default function PaymentBadge({ mode }) {
    if (!mode) return null;
    const isCod = mode === 'COD';
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                px: '6px',
                py: '2px',
                borderRadius: '3px',
                fontSize: '10px',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: '0.4px',
                bgcolor: isCod ? '#fef2f2' : '#f0fdf4',
                color: isCod ? '#dc2626' : '#16a34a',
                border: `1px solid ${isCod ? '#fecaca' : '#bbf7d0'}`,
            }}
        >
            {mode}
        </Box>
    );
}
